import React from 'react'

import { string } from 'prop-types'

import SmartTooltip from 'Pods/Shared/SmartTooltip/SmartTooltip'

function GeometryItem({ title, value, tooltipContent = null }) {
  return (
    <div className="cgt-verification-details__metric-item">
      <span className="details-area__section-subtitle">
        {tooltipContent ? (
          <SmartTooltip
            content={tooltipContent}
            id={`geometry-item-${title.replace(/\s+/g, '-').toLowerCase()}`}
            delayShow={100}
            delayHide={100}
            place="right"
          >
            <span>
              {title}
            </span>
          </SmartTooltip>
        ) : (
          title
        )}
      </span>
      <div className="details-area__section-info">
        {value}
      </div>
    </div>
  )
}

GeometryItem.propTypes = {
  title: string.isRequired,
  value: string.isRequired,
  tooltipContent: string,
}

export default GeometryItem
